<template>

    <form @submit.prevent="download">
      <div class="pane">
      <div class="steps" style="">
        <div>
          <label>
            Format:
          </label>
          <select
              v-model="form.format"
              class="form-control"
              style="width: 100%;"
          >
            <option value="xlsx">Excel (.xlsx)</option>
            <option value="csv">CSV (.csv)</option>
          </select>
        </div>

        <div>
          <label>
            Template:
          </label>
          <select
              v-model="form.partition"
              class="form-control"
              style="width: 100%;"
          >
            <option value="all">Single template (all workers)</option>
            <option value="by_site">One template per site</option>
          </select>
        </div>
      </div>

      <button
          v-if="!downloading"
          class="btn orcaBtn greenBtn"
          type="submit"
          style="margin-top: 4em;"
      >
        Download template
      </button>

        <button
            v-else
            class="btn orcaBtn greenBtn"
            disabled
            style="margin-top: 4em; display: flex; align-items: center; gap: 0.5em; justify-content: center;"
        >
          <span class="spinner"></span>
          Downloading…
        </button>
      </div>
    </form>

</template>

<style lang="scss" scoped>
.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-bottom: 1em;
}

.steps{
  display: grid;
  grid-template-columns: 50% 50%;
}

.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>

<script>
export default {
  name: 'TimesheetImportDownloadForm',

  props: {
    prefix: { required: true },
    company_id: { required: true },
    end_date: { required: true },
  },

  data() {
    return {
      downloading: false,
      form: {
        format: 'xlsx',
        partition: 'all',
      },
    };
  },

  computed: {
    apiScope() {
      return this.prefix === 'a' ? 'admin' : 'client';
    },
  },

  methods: {
    async download() {
      if (this.downloading) return;
      this.downloading = true;

      try {
        const params = new URLSearchParams();

        if (this.company_id !== 2575) {
          params.set('partition', this.form.partition);
          params.set('format', this.form.format);
        }

        params.set('unit', 'default');
        params.set('submission_date', this.end_date);

        const url =
            `${this.crmApiPath}r3/${this.apiScope}` +
            `/timesheets/company/${this.company_id}/imports/download_timesheet_tpl?` +
            params.toString();

        const r = await axios.post(url, null, { responseType: 'blob' });
        if (r.status !== 200) throw new Error('Download failed');

        let filename =
            r.headers['custom-filename'] ||
            r.headers['x-filename'] ||
            null;

        if (!filename) {
          const cd = r.headers['content-disposition'] || '';
          let m = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
          if (m && m[1]) {
            try { filename = decodeURIComponent(m[1]); }
            catch (_) { filename = m[1]; }
          }

          if (!filename) {
            m = cd.match(/filename\s*=\s*"?(.*?)"?$/i);
            if (m && m[1]) filename = m[1];
          }
        }

        if (!filename) {
          filename =
              this.form.format === 'xlsx'
                  ? 'timesheet_template.xlsx'
                  : 'timesheet_template.csv';
        }

        filename = filename
            .replace(/[\\/:*?"<>|\u0000-\u001F]+/g, '_')
            .trim();

        const hasExt = /\.[A-Za-z0-9]{1,5}$/.test(filename);
        if (!hasExt && this.form.partition !== 'by_site') {
          filename += '.' + this.form.format;
        }

        const blobUrl = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(blobUrl);

        this.$snotify?.success('Template downloaded', { timeout: 2000 });
        this.$emit('downloaded');
      } catch (_) {
        this.$snotify?.error('Failed to download template', { timeout: 3000 });
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>
